export default __webpack_public_path__ + "static/aws-deepracer-img-2-0e5635610779dab9162de5798db2c948.jpg";